import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import type { EventPrefix } from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";

interface TrackDqPageViewedParams {
  customerIoAnalytics: AnalyticsBrowser;
  eventPrefix?: EventPrefix;
}

export const trackDqPageViewed = ({
  customerIoAnalytics,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackDqPageViewedParams) => {
  triggerGoogleTagManagerTracking({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.DQ_PAGE_VIEWED}`,
  });
  void customerIoAnalytics.track(
    `${eventPrefix}${CUSTOMER_IO_EVENT.DQ_PAGE_VIEWED}`,
    {
      source: window.location.href,
    },
  );
};
